import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user_tree",
  "use": "icon-user_tree-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-user_tree\"><defs><style type=\"text/css\"></style></defs><path d=\"M128.692 127.99v191.05H319.04V127.99H128.692z m127.261 127.963h-64.169v-64.169h64.169v64.169zM511.333 704.223v191.416h385.792V704.223H511.333zM832 832H576.112v-64.198H832V832zM384.075 127.99v191.05h512.099V127.99H384.075z m448.087 127.963H448.087v-64.169h384.075v64.169zM511.333 448.209v191.416H896.23V448.209H511.333z m319.922 127.776H575.961v-64.198h255.294v64.198zM192.037 319.041h64.012v512.68h-64.012z\" p-id=\"5803\" /><path d=\"M256.05 767.802h255.284v63.919H256.05zM256.05 512h255.284v63.381H256.05z\" p-id=\"5804\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user_tree.svg
// module id = Ql5a
// module chunks = 81